import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { APPLICATION_ROUTES } from '../../constants/application-routes';

export function setupUsers(): void {

  applicationModuleRegistry.register({
    entry: 'users',
    id: 'users',
    name: 'results.user.management',
    route: APPLICATION_ROUTES.USERS
  });

}